<template>
  <div class="min-h-screen">
    <!-- 添加一个隐藏的文件输入框用于选择头像 -->
    <input type="file" id="avatar-input" accept="image/*" ref="avatarInput" @change="handleAvatarChange" class="hidden">

    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 theme-header">
        <h1 class="text-lg font-semibold text-center text-gray-800 paw-pattern">个人中心</h1>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="pt-16 pb-20 px-4">
      <!-- 用户信息卡片 -->
      <div class="bg-white rounded-2xl p-6 shadow-lg mb-6" style="background: linear-gradient(135deg, #fff, #F3F4F6);">
        <div class="flex items-center mb-6">
          <div class="relative">
            <img :src="userInfo.userImage" alt="用户头像" 
                class="w-20 h-20 rounded-full object-cover border-4 border-white shadow-lg cursor-pointer floating"
                @click="$refs.avatarInput.click()">
            <span class="absolute bottom-0 right-0 w-6 h-6 bg-white bg-opacity-90 rounded-full border-2 border-green-100 flex items-center justify-center cursor-pointer hover:bg-green-50"
                @click="$refs.avatarInput.click()">
              <!-- <font-awesome-icon icon="paw" class="text-green-500 text-xs" /> -->
              <img style="width: 11px;height: 11px;" class="text-green-500 text-xs" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paw.png"/>
            </span>
          </div>
          <div class="ml-4">
            <h2 v-if="!isEditingUsername"
              ref="usernameDisplay" 
              class="text-xl font-bold text-gray-800 mb-1 editable-username"
              @click="startEditUsername"
            >{{ userInfo.userNickname }}</h2>
            <input
              v-else
              v-model="editUsername"
              class="username-input"
              maxlength="20"
              @blur="finishEditUsername"
              @keydown.enter="finishEditUsername"
              @keydown.esc="cancelEditUsername"
              ref="usernameInput"
            />
          </div>
          <!-- <div class="ml-4">
            <h2 
              ref="usernameDisplay" 
              class="text-xl font-bold text-gray-800 mb-1 editable-username"
              @click="startEditUsername"
            >{{ userInfo.userNickname }}</h2>
          </div> -->
        </div>

        <!-- 账户数据概览 -->
        <div class="grid grid-cols-3 gap-4 mb-6">
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 shadow-sm">
            <div class="flex flex-col items-center">
              <!-- <font-awesome-icon icon="paw" class="text-2xl mb-2 theme-icon" /> -->
              <img style="width: 25px;height: 25px;" class="text-2xl mb-2 theme-icon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paw2.png"/>
              <p class="text-xs text-gray-600 mb-1">我的宠物</p>
              <p class="text-lg font-bold theme-text-primary">{{ userInfo.petsSum }}</p>
            </div>
          </div>
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 shadow-sm">
            <div class="flex flex-col items-center">
              <!-- <font-awesome-icon icon="wifi" class="text-2xl mb-2 theme-icon" /> -->
              <img style="width: 27px;height: 27px;" class="text-2xl mb-2 theme-icon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/Wi-Fi.png"/>
              <p class="text-xs text-gray-600 mb-1">在线设备</p>
              <p class="text-lg font-bold theme-text-primary">{{ userInfo.onlineInfo }}</p>
            </div>
          </div>
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 shadow-sm">
            <div class="flex flex-col items-center">
              <img style="width: 25px;height: 25px;" class="text-2xl mb-2 theme-icon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/signal.png"/>
              <!-- <font-awesome-icon icon="signal" class="text-2xl mb-2 theme-icon" /> -->
              <p class="text-xs text-gray-600 mb-1">今日活跃</p>
              <p class="text-lg font-bold theme-text-primary">{{ userInfo.activeSituationToDay }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 功能列表 -->
      <div class="space-y-4">
        <!-- 账户管理 -->
        <div class="bg-white rounded-2xl p-4 shadow-sm">
          <h3 class="text-lg font-bold text-gray-800 mb-4 px-2">账户管理</h3>
          <div class="space-y-2">
            <a href="#" @click.prevent="openPasswordModal" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <img style="width: 21px;height: 21px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/shield-alt.png"/>
                <!-- <font-awesome-icon icon="shield-alt" class="text-xl theme-icon w-8" /> -->
                <span class="text-gray-700">账号安全</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </a>
          </div>
        </div>

        <!-- 宠物管理 -->
        <div class="bg-white rounded-2xl p-4 shadow-sm">
          <h3 class="text-lg font-bold text-gray-800 mb-4 px-2">宠物管理</h3>
          <div class="space-y-2">
            <router-link to="/device-list" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <img style="width: 20px;height: 20px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paw2.png"/>
                <!-- <font-awesome-icon icon="paw" class="text-xl theme-icon w-8" /> -->
                <span class="text-gray-700">我的宠物</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </router-link>
            <router-link to="/statistics" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <img style="width: 20px;height: 20px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/history.png"/>
                <!-- <font-awesome-icon icon="history" class="text-xl theme-icon w-8" /> -->
                <span class="text-gray-700">监测记录</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </router-link>
            <router-link to="/health-record-list" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <img style="width: 20px;height: 20px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/clipboard.png"/>
                <!-- <font-awesome-icon icon="clipboard" class="text-xl theme-icon w-8" /> -->
                <span class="text-gray-700">健康记录</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </router-link>
          </div>
        </div>

        <!-- 其他功能 -->
        <div class="bg-white rounded-2xl p-4 shadow-sm">
          <h3 class="text-lg font-bold text-gray-800 mb-4 px-2">其他功能</h3>
          <div class="space-y-2">
            <a href="#" @click.prevent="openThemeModal" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <!-- <font-awesome-icon icon="cog" class="text-xl theme-icon w-8" /> -->
                <img style="width: 20px;height: 20px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/cog-fill.png"/>
                <span class="text-gray-700">系统设置</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </a>
            <!-- <a href="#" @click.prevent="openHelpCenter" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <font-awesome-icon icon="question-circle" class="text-xl theme-icon w-8" />
                <span class="text-gray-700">帮助中心</span>
              </div>
              <font-awesome-icon icon="chevron-right" class="text-gray-400" />
            </a> -->
            <a href="#" @click.prevent="contactCustomerService" class="flex items-center justify-between p-2 rounded-xl hover:bg-blue-50 transition-colors">
              <div class="flex items-center">
                <!-- <font-awesome-icon icon="headset" class="text-xl theme-icon w-8" /> -->
                <img style="width: 20px;height: 20px;" class="text-xl theme-icon w-8" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/headset.png"/>
                <span class="text-gray-700">联系客服</span>
              </div>
              <img style="width: 18px;height: 18px;" class="text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
              <!-- <font-awesome-icon icon="chevron-right" class="text-gray-400" /> -->
            </a>
          </div>
        </div>

        <!-- 退出登录按钮 -->
        <button @click="logout" class="w-full bg-white text-red-500 py-3 rounded-xl font-medium hover:bg-red-50 transition-colors mt-6">
          退出登录
        </button>
      </div>

      <!-- 修改密码弹窗 -->
      <div v-if="showPasswordModal" class="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-end justify-center">
        <div class="bg-white w-full rounded-t-2xl p-6 animate-slideUp">
          <div class="w-12 h-1 bg-gray-200 rounded-full mx-auto mb-4"></div>
          <div class="flex justify-between items-center mb-6">
            <h3 class="text-lg font-semibold text-gray-800">修改密码</h3>
            <button @click="closePasswordModal" class="text-gray-500 hover:text-gray-700">
              <!-- <font-awesome-icon icon="times" /> -->
              <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
            </button>
          </div>
          <form @submit.prevent="handlePasswordSubmit" class="space-y-4">
            <div>
              <!-- <label class="block text-sm text-gray-600 mb-2">当前密码</label> -->
              <input 
                type="password" 
                placeholder="请输入当前密码"
                v-model="passwordForm.oldPassword" 
                class="w-full px-4 py-3 rounded-xl border focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all"
                required
              >
            </div>
            <div>
              <!-- <label class="block text-sm text-gray-600 mb-2">新密码</label> -->
              <input 
                type="password" 
                placeholder="请输入新密码"
                v-model="passwordForm.userNewPassword" 
                class="w-full px-4 py-3 rounded-xl border focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all"
                required
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$"
              >
              <p class="text-xs text-gray-500 mt-1">密码必须包含大小写字母和数字，长度至少8位</p>
            </div>
            <div>
              <!-- <label class="block text-sm text-gray-600 mb-2">确认新密码</label> -->
              <input 
                type="password" 
                placeholder="请输入确认新密码"
                v-model="passwordForm.userCheckPassword" 
                class="w-full px-4 py-3 rounded-xl border focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all"
                required
              >
            </div>
            <div v-if="passwordError" class="text-red-500 text-sm">{{ passwordError }}</div>
            <button type="submit" class="w-full bg-blue-500 text-white py-3 rounded-xl hover:bg-blue-600 transition-colors font-medium">
              确认修改
            </button>
            <button type="button" @click="closePasswordModal" class="w-full bg-gray-100 text-gray-700 py-3 rounded-xl hover:bg-gray-200 transition-colors font-medium mt-2">
              取消
            </button>
          </form>
        </div>
      </div>

      <!-- 添加主题设置弹窗 -->
      <div v-if="showThemeModal" class="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-end justify-center">
        <div class="bg-white w-full rounded-t-2xl p-6 animate-slideUp">
          <div class="w-12 h-1 bg-gray-200 rounded-full mx-auto mb-4"></div>
          <div class="flex justify-between items-center mb-6">
            <h3 class="text-lg font-semibold text-gray-800">主题设置</h3>
            <button @click="closeThemeModal" class="text-gray-500 hover:text-gray-700">
              <!-- <font-awesome-icon icon="times" /> -->
              <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
            </button>
          </div>
          <div class="space-y-4">
            <div @click="setTheme('neutral')" class="p-4 rounded-xl hover:bg-gray-50 cursor-pointer">
              <div class="flex items-center justify-between mb-2">
                <span class="text-sm font-medium text-gray-700">中性色（默认）</span>
                <!-- <font-awesome-icon v-if="currentTheme === 'neutral'" icon="check" class="text-blue-500" /> -->
              </div>
              <div class="theme-option theme-neutral w-full h-16" :class="{'selected': currentTheme === 'neutral'}"></div>
            </div>
            <div @click="setTheme('warm')" class="p-4 rounded-xl hover:bg-gray-50 cursor-pointer">
              <div class="flex items-center justify-between mb-2">
                <span class="text-sm font-medium text-gray-700">暖色主题</span>
                <!-- <font-awesome-icon v-if="currentTheme === 'warm'" icon="check" class="text-blue-500" /> -->
              </div>
              <div class="theme-option theme-warm w-full h-16" :class="{'selected': currentTheme === 'warm'}"></div>
            </div>
            <div @click="setTheme('monochrome')" class="p-4 rounded-xl hover:bg-gray-50 cursor-pointer">
              <div class="flex items-center justify-between mb-2">
                <span class="text-sm font-medium text-gray-700">蒂芙尼绿主题</span>
                <!-- <font-awesome-icon v-if="currentTheme === 'monochrome'" icon="check" class="text-blue-500" /> -->
              </div>
              <div class="theme-option theme-monochrome w-full h-16" :class="{'selected': currentTheme === 'monochrome'}"></div>
            </div>
          </div>
          
          <button @click="closeThemeModal" class="w-full bg-gray-100 text-gray-700 py-3 rounded-xl hover:bg-gray-200 transition-colors font-medium mt-6">
            关闭
          </button>
        </div>
      </div>
    </main>

    <!-- 底部导航栏 -->
    <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg">
      <div class="grid grid-cols-5 py-2 theme-header">
        <router-link to="/home" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="home" class="text-xl" /> -->
          <!-- <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selHome.png"/> -->
          <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/home.png"/>
          <p class="text-xs mt-1">首页</p>
        </router-link>
        <router-link to="/location" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="map-marker-alt" class="text-xl" /> -->
          <!-- <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/SelPosition.png"/> -->
          <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/position.png"/>
          <p class="text-xs mt-1">定位</p>
        </router-link>
        <router-link to="/ai-diagnosis" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="robot" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selRobotAi.png"/> -->
          <p class="text-xs mt-1">AI问诊</p>
        </router-link>
        <router-link to="/device-list" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="microchip" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/microchip.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selMicrochip.png"/> -->
          <p class="text-xs mt-1">设备</p>
        </router-link>
        <router-link to="/profile" exact active-class="nav-active" class="routerLink">
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/user.png"/> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selUser.png"/>
          <!-- <font-awesome-icon icon="user" class="text-xl" /> -->
          <p class="text-xs mt-1">我的</p>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { ThemeManager } from '@/utils'
import { RPC } from '@/api/rpc'

export default {
  name: 'Profile',
  data() {
    return {
      showPasswordModal: false,
      showThemeModal: false,
      passwordForm: {
        oldPassword: '',
        userNewPassword: '',
        userCheckPassword: ''
      },
      passwordError: '',
      currentTheme: 'neutral',
      isEditingUsername: false,
      userId: null,
      userInfo: {}
    }
  },
  mounted() {
    this.userId = sessionStorage.getItem('info')?JSON.parse(sessionStorage.getItem('info')).userId : null
    this.getUserFun()
    // 从本地存储加载主题设置
    const savedTheme = ThemeManager.getCurrentTheme();
    if (savedTheme) {
      this.currentTheme = savedTheme;
      ThemeManager.applyTheme(savedTheme);
    }
  },
  methods: {
    getUserFun() {
      RPC.getUserInfo(this.userId).then(res=>{
        this.userInfo = res.data
      })
    },
    handleAvatarChange(e) {
      const file = e.target.files[0];
      if (file) {
        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          this.$toast?.fail?.('请选择图片文件！');
          return;
        }
        
        // 检查文件大小（限制为 5MB）
        if (file.size > 5 * 1024 * 1024) {
          this.$toast?.fail?.('图片大小不能超过 5MB！');
          return;
        }
        const client = new FormData();
        client.append('file', e.target.files[0])
        RPC.uploadPetImageFile(client).then(res=>{
          let data = {
            userId: this.userId,
            userImage: res,
            userNickname: this.userInfo.userNickname
          }
          RPC.userEditInfo(data).then(res=>{
            this.$toast?.success?.('头像已更新');
            this.getUserFun()
          })
        })
      }
    },
    startEditUsername() {
      if (this.isEditingUsername) return;
      this.editUsername = this.userInfo.userNickname;
      this.isEditingUsername = true;
      this.$nextTick(() => {
        this.$refs.usernameInput && this.$refs.usernameInput.focus();
      });
    },
    finishEditUsername() {
      const newUsername = this.editUsername.trim();
      if (newUsername && newUsername !== this.userInfo.userNickname) {
        this.userInfo.userNickname = newUsername;
        // TODO: 调用API保存到服务器
        let data = {
          userId: this.userId,
          userImage: this.userInfo.userImage,
          userNickname: this.userInfo.userNickname
        }
        RPC.userEditInfo(data).then(res=>{
          this.$toast?.success?.('用户名已更新');
        })
      }
      this.isEditingUsername = false;
    },
    cancelEditUsername() {
      this.isEditingUsername = false;
    },
    openPasswordModal() {
      this.showPasswordModal = true;
      this.passwordForm = {
        oldPassword: '',
        userNewPassword: '',
        userCheckPassword: ''
      };
      this.passwordError = '';
    },
    closePasswordModal() {
      this.showPasswordModal = false;
    },
    handlePasswordSubmit() {
      // 密码格式验证
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
      if (!passwordRegex.test(this.passwordForm.userNewPassword)) {
        this.passwordError = '新密码必须包含大小写字母和数字，长度至少8位';
        return;
      }

      // 确认密码验证
      if (this.passwordForm.userNewPassword !== this.passwordForm.userCheckPassword) {
        this.passwordError = '两次输入的密码不一致';
        return;
      }

      // 模拟成功响应
      RPC.updatePwd(this.passwordForm).then(res=>{
        this.closePasswordModal();
        this.$router.push('/login')
        this.$toast?.success?.('密码修改成功！');
        localStorage.clear();
        sessionStorage.clear();
      })
    },
    openThemeModal() {
      this.showThemeModal = true;
    },
    closeThemeModal() {
      this.showThemeModal = false;
    },
    setTheme(theme) {
      this.currentTheme = theme;
      
      // 应用主题到整个应用
      ThemeManager.applyTheme(theme);
      
      // 显示提示
      this.$toast?.success?.('主题已更新');
      
      // 关闭弹窗
      setTimeout(() => {
        this.closeThemeModal();
      }, 500);
    },
    applyTheme(theme) {
      ThemeManager.applyTheme(theme);
    },
    logout() {
      if (confirm('确定要退出登录吗？')) {
        // 清除本地存储的用户信息
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        sessionStorage.clear();
        
        // 跳转到登录页面
        this.$router.push('/login');
        this.$toast?.success?.('已退出登录');
      }
    },
    contactCustomerService() {
      this.$toast?.info?.('正在连接客服，请稍候...');
      // 实际项目中，这里应该跳转到客服页面或打开客服聊天窗口
      setTimeout(() => {
        this.$toast?.success?.('客服已接入，请开始咨询');
      }, 1500);
    },
    openHelpCenter() {
      this.$toast?.info?.('正在加载帮助中心...');
      // 实际项目中，这里应该跳转到帮助中心页面
      setTimeout(() => {
        this.$toast?.success?.('帮助中心已加载');
      }, 1000);
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #3B82F6;
  --secondary-color: #93C5FD;
  --accent-color: #2563EB;
  --background-color: #F3F4F6;
}

body {
  background-color: var(--background-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.theme-option {
  width: 100%;
  height: 60px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.theme-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.theme-option.selected {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
}

.theme-neutral {
  background: linear-gradient(45deg, #3B82F6, #93C5FD);
}

.theme-warm {
  background: linear-gradient(45deg, #F97316, #FDBA74);
}

.theme-monochrome {
  background: linear-gradient(45deg, #0ABAB5, #81D8D0);
}

.paw-pattern {
  position: relative;
}

.paw-pattern::before {
  content: '🐾';
  position: absolute;
  top: -10px;
  right: -5px;
  font-size: 20px;
  opacity: 0.3;
  transform: rotate(30deg);
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
}

.floating {
  animation: float 3s ease-in-out infinite;
}

.editable-username {
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.editable-username:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.username-input {
  border: none;
  background: transparent;
  font-size: 1.25rem;
  font-weight: bold;
  color: #1f2937;
  width: 150px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 2px solid #3B82F6;
  outline: none;
}

.hidden {
  display: none;
}

.nav-active {
  color: var(--accent-color);
}

.nav-active p {
  color: var(--primary-dark);
}

.nav-active .svg-inline--fa {
  color: var(--primary-color);
}

/* 添加从底部滑入的动画 */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.animate-slideUp {
  animation: slideUp 0.3s ease-out forwards;
}

/* 添加从顶部滑入的动画 */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.animate-slideDown {
  animation: slideDown 0.3s ease-out forwards;
}

/* 添加淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}
.w-8 {
  margin-right: 10px;
}
.routerLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
</style> 